import React from 'react';
import './CSS/PolicyPage.css';

const ContactUs = () => {
  return (
    <div className="policy-page container">
      <h1>Contact Us</h1>

      <div className="policy-section">
        <h2>1. Customer Support</h2>
        <p>We’re here to help! For any issues with your order, feedback, or inquiries, please reach out to our customer support team during working hours.</p>
        <ul>
          <li><strong>Email:</strong> nasrin.banu60@gmail.com</li>
          <li><strong>Phone:</strong> +91 95009 00281</li>
          <li><strong>Working Hours:</strong> As per the timings given in the shop page</li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>2. Feedback & Suggestions</h2>
        <p>We value your feedback! If you have any suggestions to improve our service or product quality, please write to us. Your input helps us grow and serve you better.</p>
      </div>

      <div className="policy-section">
        <h2>3. Business Inquiries</h2>
        <p>For partnerships, bulk orders, or vendor opportunities, please contact our business team at <strong>+91 95009 00281</strong>.</p>
      </div>
    </div>
  );
};

export default ContactUs;
